<script setup lang="ts">
import { Doughnut } from 'vue-chartjs'
import { 
  Chart as ChartJS, 
  Tooltip, 
  Legend, 
  ArcElement 
} from 'chart.js'

ChartJS.register(Tooltip, Legend, ArcElement)

const chartData = {
  labels: ['Operator Contribution', 'Platform Match'],
  datasets: [{ 
    data: [100, 50], 
    backgroundColor: ['#6078ea', '#17ead9'],
    borderWidth: 0
  }]
}

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom' as const,
      labels: {
        color: '#d1d1f7',
        font: { family: 'Poppins' }
      }
    }
  }
}
</script>

<template>
  <div class="text-[#d1d1f7] font-['Poppins'] p-8">
 bitumen:0:231
    <div class="max-w-6xl mx-auto">

      <h1 class="text-4xl font-black text-center mb-12 text-white">
        The <span class="bg-gradient-to-r from-[#17ead9] to-[#6078ea] bg-clip-text text-transparent">Loyalty Engine</span>
      </h1>

      <div class="grid md:grid-cols-2 gap-8">
        <div class="bg-[#1e1c36]/70 border border-[#58508d]/30 p-8 rounded-2xl">
          <h3 class="text-xl font-bold mb-4 text-white">Shared Funding Pool</h3>
          <div class="h-[300px]">
            <Doughnut :data="chartData" :options="chartOptions" />
          </div>
        </div>
        
        <div class="bg-[#1e1c36]/70 border border-[#58508d]/30 p-8 rounded-2xl flex flex-col justify-center">
          <h3 class="text-2xl font-bold mb-4 bg-gradient-to-r from-[#17ead9] to-[#6078ea] bg-clip-text text-transparent">Co-Funded Rewards</h3>
          <p class="text-lg leading-relaxed text-[#d1d1f7]/80">
            We reinvest platform profits to match operator contributions. This ensures the VIP program is the most competitive in the industry without hurting your bottom line.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700;800&display=swap');
</style>
